import { render } from "./Problem_identificationById.vue?vue&type=template&id=6dc6f772"
import script from "./Problem_identificationById.vue?vue&type=script&lang=js"
export * from "./Problem_identificationById.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__